module.exports = __webpack_public_path__ + "img/star.39874e39.png";